<template>
  <DashboardDetailLayout
    title="Job Runs"
    subtitle="Scheduled job execution, success rates, durations, and queue health."
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-1 mb-4">
      <MetricCard
        title="Last Night Success Rate"
        value="89%"
        subtitle="42 of 47 succeeded"
        valueTone="warn"
        borderTone="warn"
        :fakeData="true"
      />
      <MetricCard
        title="Avg Duration (7d)"
        value="4m 12s"
        trend="8s slower vs 30d avg"
        trendDirection="down"
        :fakeData="true"
      />
      <MetricCard
        title="Failed Jobs (7d)"
        value="23"
        valueTone="bad"
        trend="12% lower than prev week"
        trendDirection="up"
        :fakeData="true"
      />
      <MetricCard
        title="Queue Depth"
        value="17"
        subtitle="Pending celery tasks"
        badge="live"
        badgeTone="info"
        :fakeData="true"
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-1 mb-4">
      <ChartPlaceholder
        title="Nightly Success vs Failure"
        subtitle="Last 14 nights"
        :barCount="14"
        :seed="3"
        tall
      />
      <ChartPlaceholder
        title="Avg Job Duration"
        subtitle="Daily, last 14 days"
        :barCount="14"
        :seed="7"
        tall
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-1 mb-4">
      <ChartPlaceholder
        title="Queue Depth Over Time"
        subtitle="Hourly, last 24 hours"
        :barCount="24"
        :seed="11"
      />
      <ChartPlaceholder
        title="Top 10 Slowest Jobs"
        subtitle="By average duration"
        :barCount="10"
        :seed="13"
      />
    </div>

    <div class="rounded-md border-2 border-dashed border-gray-300 bg-neutral-50 shadow p-3 m-2">
      <div class="flex flex-row items-center space-x-2 mb-2">
        <div class="text-sm tracking-widest text-gray-700 font-poppins uppercase">
          Recent Failed Runs
        </div>
        <SampleBadge />
      </div>
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-gray-500 border-b">
            <th class="py-1">Job</th>
            <th class="py-1">Started</th>
            <th class="py-1">Duration</th>
            <th class="py-1">Error</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in sampleFailures" :key="row.id" class="border-b last:border-0">
            <td class="py-1 font-mono text-xs">{{ row.job }}</td>
            <td class="py-1">{{ row.started }}</td>
            <td class="py-1">{{ row.duration }}</td>
            <td class="py-1 text-rose-700">{{ row.error }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </DashboardDetailLayout>
</template>

<script setup>
import DashboardDetailLayout from '../DashboardDetailLayout.vue'
import MetricCard from '../MetricCard.vue'
import ChartPlaceholder from '../ChartPlaceholder.vue'
import SampleBadge from '../SampleBadge.vue'

const sampleFailures = [
  { id: 1, job: 'nightly_company_enricher', started: '2026-04-20 01:14a', duration: '27m 03s', error: 'Timeout: ZoomInfo API' },
  { id: 2, job: 'campaign_change_report',   started: '2026-04-20 02:02a', duration: '0m 12s',  error: 'ConnectionReset on SMTP' },
  { id: 3, job: 'deduper_sweep',            started: '2026-04-20 03:00a', duration: '8m 41s',  error: 'IntegrityError on merge' },
  { id: 4, job: 'invoice_reminders',        started: '2026-04-20 03:30a', duration: '0m 04s',  error: 'Missing template: overdue_v2' },
  { id: 5, job: 'wave_sync',                started: '2026-04-20 04:12a', duration: '1m 27s',  error: 'Wave 401: token expired' },
]
</script>